module.exports = __webpack_public_path__ + "media/images/new_user-b8668fed7cc2512bb907eb9790be144a.svg";